import React, { useEffect } from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 13c-2.757 0-5-2.243-5-5 0-1.2.428-2.298 1.134-3.16l7.027 7.026A4.974 4.974 0 018 13zm6 .291l-1.422-1.422-.708-.708L4.84 4.13l-.71-.708-1.422-1.423-.707.707 1.428 1.428A5.954 5.954 0 002 8c0 3.309 2.691 6 6 6 1.475 0 2.82-.542 3.866-1.43l1.427 1.428.708-.707zM8 3c2.757 0 5 2.243 5 5 0 .833-.208 1.617-.57 2.308l.733.733A5.957 5.957 0 0014 8c0-3.309-2.692-6-6-6a5.954 5.954 0 00-3.041.837l.733.732A4.968 4.968 0 018 3z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 19.5c-4.136 0-7.5-3.364-7.5-7.5 0-1.799.642-3.447 1.701-4.74l10.54 10.539A7.461 7.461 0 0112 19.5zm9.001.437l-2.134-2.133-1.062-1.063L7.259 6.195 6.196 5.133 4.062 2.998 3.001 4.06l2.143 2.142A8.931 8.931 0 003 12c0 4.963 4.037 9 9 9 2.213 0 4.23-.813 5.799-2.144l2.141 2.142 1.061-1.061zM12 4.5c4.137 0 7.5 3.364 7.5 7.5a7.452 7.452 0 01-.854 3.462l1.1 1.099A8.929 8.929 0 0021 12c0-4.963-4.038-9-9-9a8.929 8.929 0 00-4.562 1.255l1.1 1.099A7.452 7.452 0 0112 4.5z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 39c-8.272 0-15-6.728-15-15 0-3.598 1.284-6.894 3.402-9.482l21.08 21.08C30.894 37.716 27.598 39 24 39zm18.002.874l-4.268-4.266-2.124-2.126L14.518 12.39l-2.126-2.124-4.268-4.27-2.122 2.122 4.286 4.284C7.626 15.54 6 19.574 6 24c0 9.926 8.074 18 18 18 4.426 0 8.46-1.626 11.598-4.288l4.282 4.284 2.122-2.122zM24 9c8.272 0 15 6.728 15 15 0 2.498-.624 4.85-1.708 6.924l2.198 2.198A17.858 17.858 0 0042 24c0-9.926-8.074-18-18-18-3.332 0-6.444.926-9.122 2.51l2.198 2.198A14.903 14.903 0 0124 9z",
    clipRule: "evenodd"
  }))
};
export var BrightnessNone = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});
BrightnessNone.displayName = "[Deprecated] BrightnessNone";